import React, { useEffect, useState } from 'react'
import { useSpeechStore } from '../../Contexts/SpeechContext'
import { useViewStore } from '../../Contexts/ViewContext'
import { useUtilsStore } from '../../Contexts/UtilsContext'
import useFullscreenImage from '../../../hooks/useFullscreenImage'

import { CloseButtonCause, CurrentSubView, ListStatus, Mode, RemoteButtonType, RetorikEvent, Routes } from '../../../models/enums'

import MicrophoneButton from '../Common/MicrophoneButton'
import RemoteButton from './RemoteButton'

interface MicrophoneAndSwitchProps {
  top?: number | string
}

const MicrophoneAndSwitch = ({ top }: MicrophoneAndSwitchProps): JSX.Element => {
  const fullScreenImage = useFullscreenImage()
  const mode = useSpeechStore((state) => state.mode)
  const isLandscape = useViewStore((state) => state.isLandscape)
  const route = useViewStore((state) => state.route)
  const currentSubView = useUtilsStore((state) => state.currentSubView)
  const dashboardOpened = useUtilsStore((state) => state.dashboardOpened)
  const retorikEvent = useUtilsStore((state) => state.retorikEvent)
  const listStatus = useUtilsStore((state) => state.listStatus)
  const [showCloseButton, setShowCloseButton] = useState<CloseButtonCause>(CloseButtonCause.none)
  const [bottomForBorne, setBottomForBorne] = useState<string>()

  useEffect(() => {
    if (
      !isLandscape &&
      (currentSubView !== CurrentSubView.none || dashboardOpened || retorikEvent === RetorikEvent.DetailViewOpen || listStatus === ListStatus.opened || route === Routes.News || fullScreenImage)
    ) {
      if (retorikEvent === RetorikEvent.DetailViewOpen && currentSubView === CurrentSubView.none) {
        setShowCloseButton(CloseButtonCause.detailedpoi)
      } else if (listStatus === ListStatus.opened) {
        setShowCloseButton(CloseButtonCause.list)
      } else if (currentSubView !== CurrentSubView.none) {
        switch (currentSubView) {
          case CurrentSubView.emergency:
            setShowCloseButton(CloseButtonCause.emergency)
            break
          case CurrentSubView.history:
            setShowCloseButton(CloseButtonCause.history)
            break
          case CurrentSubView.languages:
            setShowCloseButton(CloseButtonCause.languages)
            break
          case CurrentSubView.weather:
            setShowCloseButton(CloseButtonCause.weather)
            break
        }
      } else if (dashboardOpened) {
        setShowCloseButton(CloseButtonCause.dashboard)
      } else if (route === Routes.News) {
        setShowCloseButton(CloseButtonCause.news)
      } else if (fullScreenImage) {
        setShowCloseButton(CloseButtonCause.fullscreenimage)
      }
    } else {
      setShowCloseButton(CloseButtonCause.none)
    }
  }, [isLandscape, currentSubView, dashboardOpened, retorikEvent, listStatus, route, fullScreenImage])

  useEffect(() => {
    if (!top || isLandscape) {
      setBottomForBorne(undefined)
    } else {
      setBottomForBorne(typeof top === 'number' ? `calc(100% - ${top}px + 0.5rem)` : `calc(100% - ${top} + 0.5rem)`)
    }
  }, [isLandscape, top])

  return (
    <div
      id='retorik-microphone-container'
      className={`large-vertical:rf-absolute rf-w-fit ${
        showCloseButton !== CloseButtonCause.none ? 'rf-right-9' : 'rf-right-4'
      } landscape-retorik:-rf-mt-4 landscape-retorik:rf-pl-[calc(50%-2.5rem)] rf-flex rf-flex-row large-vertical:rf-flex-col rf-justify-center rf-items-center rf-gap-6 large-vertical:rf-gap-4`}
      style={{
        bottom: bottomForBorne
      }}
    >
      {/* Microphone button hidden if showCloseButton is true */}
      {mode === Mode.vocal && <MicrophoneButton hidden={showCloseButton !== CloseButtonCause.none} />}
      {(showCloseButton !== CloseButtonCause.none || mode === Mode.vocal) && <RemoteButton type={showCloseButton !== CloseButtonCause.none ? RemoteButtonType.close : RemoteButtonType.text} backgroundColor='#FFF' cause={showCloseButton} />}
    </div>
  )
}

export default MicrophoneAndSwitch
